<template>
  <div class="flex justify-evenly p-[10px] rounded bg-white">
    <template v-for="(item, index) in items">
      <StatisticBlock
        :key="index"
        class="!h-auto"
        :title="item.title"
        :hint="item.hint"
        :value="item.value"
      />
      <el-divider
        v-if="index < items.length - 1"
        :key="index"
        direction="vertical"
        class="h-auto self-stretch"
      />
    </template>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import StatisticBlock from './StatisticBlock.vue'

export default defineComponent({
  name: 'StatisticOverview',
  components: {
    StatisticBlock,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
})
</script>
